<template>
  <b-modal
    id="cancel-service-system-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.confirm')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('breadcrumb.updateServiceSystem')"
    :loading="loading"
    @ok="handleOk"
    @cancel="$emit('cancel')"
    @close="$emit('cancel')"
  >
    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        class="btn"
        @click="$emit('cancel')"
      >
        {{ $t('button.close') }}
      </b-button>
      <n-button-loading
        :loading="loading"
        class="btn"
        variant="primary"
        @submit="handleOk"
      >
        {{ $t('button.confirm') }}
      </n-button-loading>
    </template>
    <validation-observer
      ref="cancelServiceSystemForm"
    >
      <n-input
        v-model="data"
        :fields="formInput"
      />
    </validation-observer>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import NInput from '@/components/NInput.vue'
import useJwt from '@/auth/jwt/useJwt'
import NButtonLoading from '@/components/NButtonLoading.vue'
import FormInput from './cancelServiceSystemFormInput'

export default {
  components: {
    BModal,
    NInput,
    BButton,
    NButtonLoading,
  },
  props: {
    activeRoom: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    shown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {
        remark: '',
      },
      key: 1,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },
  watch: {
    shown(val) {
      if (val) {
        this.data.remark = ''
        this.show()
      } else {
        this.hide()
      }
    },
  },
  methods: {
    show() {
      this.key += 1
      this.$bvModal.show('cancel-service-system-modal')
    },
    hide() {
      this.$bvModal.hide('cancel-service-system-modal')
    },
    handleOk(bvModal) {
      if (bvModal) bvModal.preventDefault()

      this.$refs.cancelServiceSystemForm.validate().then(success => {
        if (success) {
          this.submit()
        }
      })
    },
    submit() {
      this.$emit('update', 0, this.data.remark)
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
